export const env = {
	API_ENDPOINT_URL:
	  process.env.REACT_APP_API_BASE_URL || 'https://node.aivideobuilder.com/app'
  };
  